import { IconButton, Tooltip } from "@mui/material";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import AddIcon from "@mui/icons-material/Add";

export default function NotesCell({ row, value, onNoteClick }) {
  const hasNote = row?.hasNote || false;
  const noteText = value || "";
  const brandColor = "#627CFB";

  return (
    <Tooltip title={hasNote ? "View/Edit Note" : "Add Note"}>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          if (onNoteClick) {
            onNoteClick(row, noteText);
          }
        }}
        sx={{
          color: brandColor,
          "&:hover": {
            backgroundColor: "rgba(98, 124, 251, 0.1)",
          },
        }}
      >
        {hasNote ? (
          <StickyNote2Icon fontSize="small" />
        ) : (
          <AddIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
